import { render, staticRenderFns } from "./leftProduct.vue?vue&type=template&id=f7e861c6&scoped=true"
import script from "./leftProduct.vue?vue&type=script&lang=js"
export * from "./leftProduct.vue?vue&type=script&lang=js"
import style0 from "./leftProduct.vue?vue&type=style&index=0&id=f7e861c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e861c6",
  null
  
)

export default component.exports